export enum StatusCode {
  SERVER_DOWN = 0,
  NOT_FOUND = 404,
  FORBIDDEN = 403,
  UNAUTHORIZED = 401,
  CONFLICT = 409,
  SERVER_ERROR = 500,
  BAD_REQUEST = 400,
  UNPROCESSABLE_CONTENT = 422,
}
